import React, { Suspense, Fragment } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Hidden } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import { routes } from "src/routes";
import { createBrowserHistory } from "history";
import AuthContext from "src/context/Auth";
import PageLoading from "src/component/PageLoading";
import AuthGuard from "src/component/AuthGuard";
// import GuestUser from "src/component/GuestUser";
import { ThemeProvider } from "@material-ui/core";
import { createTheme } from "src/theme";
import { Toaster } from "react-hot-toast";
import LandscapeWarning from "./component/LandscapeWarning";
// import Cookies from "js-cookie";
// import "animate.css/animate.min.css";
const history = createBrowserHistory();

function App() {
  const theme = createTheme();
  const toasterOptions = {
    style: {
      fontSize: "16px", // Adjust the font size here
      wordBreak: "break-word",
      fontFamily: "Arial",
    },
  };

  return (
    <div className="App">
      <Hidden xsDown>
        <LandscapeWarning />
      </Hidden>
      <ThemeProvider theme={theme}>
        {" "}
        <Toaster position="top-center" toastOptions={toasterOptions} />
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <AuthContext>
            <Router history={history}>
              <RenderRoutes data={routes} />
            </Router>
          </AuthContext>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;

function RenderRoutes(props) {
  return (
    <Suspense fallback={<PageLoading />}>
      <Switch>
        {props.data.map((route, i) => {
          const Component = route.component;
          const Guard = route.guard ? AuthGuard : Fragment;
          const Layout = route.layout || Fragment;
          return (
            <Route
              exact={route.exact}
              key={i}
              path={route.path}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      <RenderRoutes data={route.routes} />
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}
